<template>
    <center v-if="iDat">
        <div style="height:90px;"></div>
        <div ref="info1container" class="imgcontainer">
            <img ref="info1Img" id="bgimg" width="800" height="600" :src="iDat.bg.picture" border="0"/>
            <div id="title" class="top-center">{{ iDat.bg.title }}</div>

            <Info1Btn
        v-for="note in iDat.notes"
        v-bind:key="note.ID"
        v-bind:ID="note.ID"
        v-bind:x="note.position.x"
        v-bind:y="note.position.y"
        v-on:btnClicked="btnClicked"
      />
        </div>

        <b-modal id="info1Modal" :title="iDat.modalData.title" :modal-footer="false" hide-footer>
            <center>
                <img v-if="iDat.modalData.picture != null" :src="iDat.modalData.picture" class="col-12 img-responsive" style="height: 250px; object-fit: contain;">
            </center>
            <p>{{iDat.modalData.description}}</p>
        </b-modal>
    </center>
</template>
<script>
    import { ajaxGet,ajaxPost } from "../../../ajax";
import Info1Btn from './Info1Btn'
    import {apiUrl} from "@/main";

export default {
    components: {Info1Btn},
    data: function() {
        return {
            iDat: undefined,
            infoId: undefined
        }
    },
    created() {
        // this.LoadNotes(this.iDat.notes);
            this.infoId = this.$router.history.current.params.infoId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.infoId == 'undefined') alert("Not part of assignment.");
            // console.log("ASSIGNMENT FLAG:", assignmentFlag);
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
            (dat) => {
                //on success dat is called
                if(dat.component == "infographic1"){
                    //This is the right component
                    this.iDat = dat.data;
                    this.isAnswered = dat.answers;
                    window.document.title = dat.title
                    //----------------------------------------------------------
                    if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                        ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
                        Data: {
                            seen: Date.now()
                        }
                    },
                    (suc) => {
                        console.log("Posted assignment:", suc);
                    },
                    (err) => {
                        console.log("Error :", err)
                    }, localStorage.token);
                    }
                    //----------------------------------------------------------
                }else{
                    //Wrong component type
                    console.error("DATA MISMATCH on api call expected 'INFOGRAPHIC1' object, got '" + dat.component.toUpperCase() + "' object.");
                }
            },(err) => {
                //There was some error
                console.log(err);
            }, localStorage.token);
    },
    methods: {
        LoadNotes: function(notes) {
            //replace with ajax << NO!
            // console.log(JSON.stringify(this.iDat));
        },
        btnClicked(ID) {
            for(var ind = 0; ind < this.iDat.notes.length; ind++) {
                if(this.iDat.notes[ind].ID == ID) {
                    this.iDat.modalData.title = this.iDat.notes[ind].title;
                    this.iDat.modalData.picture = this.iDat.notes[ind].picture;
                    this.iDat.modalData.description = this.iDat.notes[ind].description;
                    
                    this.$bvModal.show("info1Modal");
                    return;
                }
            }

            this.iDat.modalData = {
                title: "",
                picture: null,
                description: ""
            };
        }
    }
}
</script>
<style scoped>
.imgcontainer {
    position: relative;
    width: 800px;
    max-width: 800px;
    height: 600px;
    max-height: 600px;
}

.top-center {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0);
  max-width:800px;
  width:800px;
  background-color: rgba(0,0,0,0.65);
  color: rgba(255,255,255,255);
  padding: 10px;
  font-size: 24px;
}

#bgimg{
    object-fit: contain;
    background: #121212;
}
</style>